import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';
import ProductPlaceholderPNG from '@assets/png/product.png';

import { ITooltip } from '@components/Tooltip';

import { IEquipment, IEquipmentWithoutProduct } from '@models/Equipment.model';
import {
  Overlay,
  Container,
  Header,
  Title,
  TitleText,
  CloseButton,
  ProductInfoContainer,
  ImagePlaceHolder,
  ProductImage,
  ProductInfoSection,
  ProductName,
  ProductInfo,
  ProductParagraph,
  ProductActions,
  ActionButton,
  ProductToolTip,
  ProductNameContainer,
  ModelEmpty,
  ProductNameEmpty,
  Arrow,
} from './MatchChanged.styles';

interface IMatchChanged {
  open: boolean;
  onClose: () => void;
  asset: IEquipment | IEquipmentWithoutProduct;
  updatedAsset: IEquipment;
}

export const MatchChanged = ({
  open,
  onClose,
  asset,
  updatedAsset,
}: IMatchChanged) => {
  const portalDiv = document.getElementById('portal');

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>
                <BlueIcon icon="tick-circle" color="#52BD94" />
                <TitleText>Match Changed!</TitleText>
              </Title>
              <CloseButton onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </CloseButton>
            </Header>
            <ProductInfoContainer>
              <ImagePlaceHolder>
                <ProductImage
                  src={asset.product?.imageUrl || ProductPlaceholderPNG}
                  brokenSrc={ProductPlaceholderPNG}
                />
              </ImagePlaceHolder>
              <ProductInfoSection>
                <ProductNameContainer>
                  {asset.product?.name ? (
                    <ProductName line>{asset.product?.name}</ProductName>
                  ) : (
                    <ProductNameEmpty line>Empty</ProductNameEmpty>
                  )}

                  {asset.product?.status === 'internal' && (
                    <ProductToolTip
                      data-for="productDialogNameTooltipId"
                      data-tip="Product Name Tooltip"
                    >
                      <BlueIcon icon="issue" color="#8F95B2" size={12} />
                      <ITooltip
                        id="productDialogNameTooltipId"
                        getContent={() => {
                          return (
                            <ProductParagraph color="#fff">
                              Internal Product
                            </ProductParagraph>
                          );
                        }}
                      />
                    </ProductToolTip>
                  )}
                </ProductNameContainer>
                <ProductInfo>
                  <ProductParagraph
                    size="12px"
                    lineHeight={18}
                    color=" #8f95b2"
                  >
                    Model:
                  </ProductParagraph>
                  {asset.product?.model ? (
                    <ProductParagraph size="12px" lineHeight={18} line>
                      {asset.product?.model}
                    </ProductParagraph>
                  ) : (
                    <ModelEmpty line>Empty</ModelEmpty>
                  )}
                </ProductInfo>
                <ProductInfo>
                  <ProductParagraph
                    size="12px"
                    lineHeight={18}
                    color=" #8f95b2"
                  >
                    Manufacturer:
                  </ProductParagraph>
                  {asset.product?.manufacturer?.name ? (
                    <ProductParagraph size="12px" lineHeight={18} line>
                      {asset.product?.manufacturer?.name}
                    </ProductParagraph>
                  ) : (
                    <ModelEmpty line>Empty</ModelEmpty>
                  )}

                  {asset.product?.manufacturer.status === 'internal' && (
                    <ProductToolTip
                      data-for="productDialogManufacturerTooltipId"
                      data-tip="Manufacturer Tooltip"
                    >
                      <BlueIcon icon="issue" color="#8F95B2" size={12} />
                      <ITooltip
                        id="productDialogManufacturerTooltipId"
                        getContent={() => {
                          return (
                            <ProductParagraph color="#fff">
                              Internal Manufacturer
                            </ProductParagraph>
                          );
                        }}
                      />
                    </ProductToolTip>
                  )}
                </ProductInfo>
              </ProductInfoSection>
            </ProductInfoContainer>
            <Arrow>
              <BlueIcon icon="arrow-down" color="#8F95B2" />
            </Arrow>
            <ProductInfoContainer border>
              <ImagePlaceHolder>
                <ProductImage
                  src={updatedAsset.product?.imageUrl || ProductPlaceholderPNG}
                  brokenSrc={ProductPlaceholderPNG}
                />
              </ImagePlaceHolder>
              <ProductInfoSection>
                <ProductNameContainer>
                  {updatedAsset.product?.name ? (
                    <ProductName>{updatedAsset.product?.name}</ProductName>
                  ) : (
                    <ProductNameEmpty>Empty</ProductNameEmpty>
                  )}

                  {updatedAsset.product?.status === 'internal' && (
                    <ProductToolTip
                      data-for="productDialogNameTooltipId"
                      data-tip="Product Name Tooltip"
                    >
                      <BlueIcon icon="issue" color="#8F95B2" size={12} />
                      <ITooltip
                        id="productDialogNameTooltipId"
                        getContent={() => {
                          return (
                            <ProductParagraph color="#fff">
                              Internal Product
                            </ProductParagraph>
                          );
                        }}
                      />
                    </ProductToolTip>
                  )}
                </ProductNameContainer>
                <ProductInfo>
                  <ProductParagraph
                    size="12px"
                    lineHeight={18}
                    color=" #8f95b2"
                  >
                    Model:
                  </ProductParagraph>
                  {updatedAsset.product?.model ? (
                    <ProductParagraph size="12px" lineHeight={18}>
                      {updatedAsset.product?.model}
                    </ProductParagraph>
                  ) : (
                    <ModelEmpty>Empty</ModelEmpty>
                  )}
                </ProductInfo>
                <ProductInfo>
                  <ProductParagraph
                    size="12px"
                    lineHeight={18}
                    color=" #8f95b2"
                  >
                    Manufacturer:
                  </ProductParagraph>
                  {updatedAsset.product?.manufacturer?.name ? (
                    <ProductParagraph size="12px" lineHeight={18}>
                      {updatedAsset.product?.manufacturer?.name}
                    </ProductParagraph>
                  ) : (
                    <ModelEmpty>Empty</ModelEmpty>
                  )}

                  {updatedAsset.product?.manufacturer.status === 'internal' && (
                    <ProductToolTip
                      data-for="productDialogManufacturerTooltipId"
                      data-tip="Manufacturer Tooltip"
                    >
                      <BlueIcon icon="issue" color="#8F95B2" size={12} />
                      <ITooltip
                        id="productDialogManufacturerTooltipId"
                        getContent={() => {
                          return (
                            <ProductParagraph color="#fff">
                              Internal Manufacturer
                            </ProductParagraph>
                          );
                        }}
                      />
                    </ProductToolTip>
                  )}
                </ProductInfo>
              </ProductInfoSection>
            </ProductInfoContainer>

            <ProductActions>
              <ActionButton data-blue onClick={onClose}>
                Back to Asset Page
              </ActionButton>
            </ProductActions>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
